import { cn } from '@sr/ui-library';
import { ReactNode } from 'react';

export const PreLoginCard = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div className="single-customer-app flex min-h-screen w-full flex-col items-center justify-center px-4 py-10">
    <img
      alt="Screenrights"
      className="mb-6 block h-auto w-48"
      height={40}
      src="/screenrights-logo.svg"
      width={192}
    />
    <div
      className={cn(
        'w-full max-w-md rounded-xl border border-border bg-card p-8 shadow-sm',
        className,
      )}
    >
      {children}
    </div>
  </div>
);
